<template>

    <div class="container mx-3 my-3">
        
        <div v-if="current_user && current_user.isAnonymous">
            <h1 class="title">Connect to an account</h1>
            <p>By connecting to an social media account we'll store all your submissions for you. It also means we score your submissions more highly</p>

            <div class="buttons is-centered mt-3">
                <button 
                    v-if="current_user && current_user.isAnonymous"
                    class="button google is-large" 
                    @click="linkWithGoogle"> 
                    <span class="icon"><i class="fab fa-google"></i></span>
                    <span>Connect Google</span>
                </button>

                <button 
                    v-if="current_user && current_user.isAnonymous"
                    class="button facebook is-large" 
                    @click="linkWithFacebook"> 
                    <span class="icon"><i class="fab fa-facebook"></i></span>
                    <span>Connect Facebook</span>
                </button>
            </div>
        </div>

        <div v-else-if="current_user">
            <h1 class="title">Already Connected</h1>
            <p>Currently connected to 
                {{ current_user.displayName || current_user.providerData[0].displayName }}
                via {{ current_user.providerData[0].providerId}}
            </p>
            <div class="buttons is-centered mt-3">
                <button
                    :class="{'': false}" class="button is-large is-primary" 
                    @click="$router.push('/logout')"> 
                    <span class="icon"><i class="fas fa-key"></i></span>
                    <span>Logout</span>
                </button>  
            </div>
            
        </div>

        <div v-else>
            <h2 class="subtitle">Loading...</h2>
            <progress class="progress is-small is-primary" max="100">loading</progress>   
        </div>

    </div>
    
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import firebase from "firebase/app"
export default {
    computed:{
        ...mapGetters({ current_user: 'current_user'})
    },
    methods: {
        ...mapActions({ 
            storeCurrentUser:'storeCurrentUser',
            mergeData: 'mergeData',
            setMessage: 'setMessage',
            loading: "loading",
        }),
        linkWithGoogle() {
            var provider = new firebase.auth.GoogleAuthProvider();
            this.linkWithProvider(provider)
        },
        linkWithFacebook() {
            var provider = new firebase.auth.FacebookAuthProvider();
            provider.setCustomParameters({ 'display': 'popup' });
            this.linkWithProvider(provider)
        },
        linkWithProvider(provider) {
            console.debug("Linking with Anonymous User", this.current_user)
            var origUser = this.current_user
            // Sign in user with the account you want to link to
            origUser.linkWithPopup(provider).then((linkResult) => {
                console.log("Link with Popup Result: ",linkResult)
                return firebase.auth().signInWithCredential(linkResult.credential).then((signInResult) => {
                    console.debug("Signed in with new creds",signInResult)
                });
            }).catch((error) => {
                console.debug("Error in original Link",error," User:",this.current_user)
                // Errors we can deal with nicely
                if(error.code == "auth/credential-already-in-use" || error.code == "auth/provider-already-linked") {
                    // Login using these credntials
                    firebase.auth().signInWithCredential(error.credential).then(()=>{
                        // Marge and data attached to origUser 
                        const unsubscribe = firebase.auth().onAuthStateChanged(user => {
                            unsubscribe();
                            console.log(origUser.uid,user.uid)
                            this.mergeData({from: origUser.uid,to: user.uid})   
                        });
                    })  
                } else {
                    // We can;t deal lets go back
                    console.debug("Reseting to original user ",origUser)
                    this.storeCurrentUser(origUser)
                    if (error.code == "auth/operation-not-allowed") {
                        this.loading(false)
                        this.setMessage({text: "Sorry this social media service isn't working, probably their fault.... [starts workling on it]", type: "is-danger" })
                    } else if(error.code == "auth/popup-closed-by-user") {
                        this.loading(false)
                    } else {
                        console.error("Uncaught Error: ",error.code,error.message)
                        this.setMessage({text: "Couldn't connect because " + error.code, type: "is-danger" })
                    }
                }
                
            });
            this.storeCurrentUser(firebase.current_user)
            this.$router.push({name: 'general.home'})
        }
    }
}
</script>

<style scoped>
    .fa-google {
        background: conic-gradient(from -45deg, #ea4335 110deg, #4285f4 90deg 180deg, #34a853 180deg 270deg, #fbbc05 270deg) 73% 55%/150% 150% no-repeat;
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        -webkit-text-fill-color: transparent;
    }
    .facebook {
        background-color: #3b5998;
        color: #fff!important;
    }
</style>